import React, { useCallback, useEffect, useState } from "react";

// assets
import { ICONS } from "assets/icons";
import Arrow from "../../../assets/customSVG/accounts/Arrow";

import { connectWhatsapp } from "../constants/index";
import { useNavigate } from "react-router-dom";

const WhatAppBusiness = ({ setupData, launchWhatsAppSignup }) => {
  const navigate = useNavigate();
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(1);
  const [selectedText, setSelectedText] = useState({
    subtitle: "",
    description: "",
    content: "",
    button: "",
    key: "",
    button1: "",
  });

  const handleDropDown = () => {
    setIsContentVisible(!isContentVisible);
  };

  const handleClick = ({
    id,
    subtitle,
    description,
    button,
    button1,
    content,
    key,
  }) => {
    setSelectedId(id);
    setSelectedText({ subtitle, description, button, button1, content, key });
  };

  const current = Object.values(setupData).filter(
    (value) => value === true
  ).length;

  const percentage = (current / 5) * 100;

  const handleButtonClick = () => {
    switch (selectedId) {
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;
      case 4:
        break;
      case 5:
        break;
      default:
    }
  };

  const getButtonStyle = () => {
    return "bg-[#05805C24] text-[#05805C] cursor-auto";

    return selectedId === 1
      ? "bg-[#1778F2] text-white"
      : "bg-[#F6A72329] text-[#F6A723]";
  };

  useEffect(() => {
    if (isContentVisible && connectWhatsapp?.length > 0) {
      const firstItem = connectWhatsapp[0];
      setSelectedId(firstItem.id);
      setSelectedText({
        subtitle: firstItem.subtitle,
        description: firstItem.description,
        button: firstItem.button,
        content: firstItem.content,
        button1: firstItem.button1,
        key: firstItem.key || "",
      });
    }
  }, [isContentVisible, connectWhatsapp]);

  const business_id = setupData?.business_id;

  const handleNavigate = () => {
    if (selectedText?.button === "Create Campaign") {
      navigate("/user/campaign/all-campaigns");
    } else if (selectedText?.button === "Start Business Verification") {
      window.open(
        `https://business.facebook.com/settings/security??business_id=${business_id}`
      );
    } else if (selectedText?.button === "Manage Payment") {
      window.open(
        ` https://business.facebook.com/billing_hub/accounts/details?business_id=${business_id}&placement=standalone&account_type=whatsapp-business-account`
      );
    } else if (selectedText?.button === "Connect with Facebook") {
      launchWhatsAppSignup();
    }
  };

  return (
    // <div
    //   className={`${
    //     isContentVisible ? "h-[28vw]" : "h-[6.5vw]"
    //   } bg-white rounded-[1vw] pl-[1vw] py-[1.5vw] pr-[0.5vw] transition-all duration-400 ease-in-out`}
    // >
    <div
      className={` bg-white rounded-[1vw] pr-[1vw] transition-all duration-400 ease-in-out`}
    >
      <div
        className={`flex justify-between items-center ${
          isContentVisible && "pb-[1vw] "
        }`}
      >
        <div className="pl-20 pt-20">
          <div className="flex items-center mb-[0.4vw] ">
            <img src={ICONS?.whatsApp} className="w-[20px] h-[20px]" />
            {current >= 3 ? (
              <p className="font20px-500 text-[var(--textBlack)] pl-5 ">
                Congratulations! Your WhatsApp business API is live and ready to
                use 🎉
              </p>
            ) : (
              <p className="font20px-500 text-[var(--textBlack)] pl-5 ">
                Get your WhatsApp Business API Live 🎉
              </p>
            )}
          </div>
          <p
            className={`font16px-400 text-[var(--font-600)] ${
              isContentVisible ? "" : "pb-20"
            } `}
          >
            Let's set up your GainWix account together in easy steps.
          </p>
        </div>
        <div className="flex items-center">
          <div className="relative inline-block mr-4">
            <div className="p-2 rounded-full border-[0.35vw] border-gray-200">
              <div
                className="absolute inset-0 rounded-full"
                style={{
                  background: `conic-gradient(#05805C ${percentage}%, transparent ${percentage}%, transparent 100%)`,
                  WebkitMask: "radial-gradient(transparent 60%, black 61%)",
                  mask: "radial-gradient(transparent 60%, black 61%)",
                }}
              />
              <div className="flex items-center justify-center h-full">
                <p className="font-semibold text-gray-600 text-sm">
                  {current}/{5}
                </p>
              </div>
            </div>

            {/* <div className="p-1.5 rounded-full border-[0.35vw] border-[#F6A723]">
              <img
                src={ICONS?.homeAlert}
                alt="homeWarning"
                className="w-[2vw] h-[2vw]"
              />
            </div> */}
          </div>
          <img
            src={ICONS?.BroadcastLightChevronDown}
            className={`w-[25px] h-[25px] pointer transition-transform duration-500 ease-in-out ${
              isContentVisible ? "rotate-180" : "rotate-0"
            }`}
            onClick={handleDropDown}
          />
        </div>
      </div>
      {isContentVisible && (
        <div
          className={`py-5 p-2 ml-20 transition-opacity duration-400 ease-in-out flex flex-row justify-center opacity-100 translate-y-0 border-t-[1px] boredr-[var(--border-input)]`}
          style={{ transition: "opacity 0.4s, transform 0.5s" }}
        >
          <div className="bg-[#F9F9FC] rounded-xl p-15 w-40">
            {connectWhatsapp?.map((data) => (
              <div
                key={data.id}
                className={`flex flex-row mt-10 items-center pointer p-10 ${
                  selectedId === data?.id &&
                  "bg-white border border-[#E8E8EA] rounded-lg font-[500]"
                }`}
                onClick={() => handleClick(data)}
              >
                <img
                  src={
                    setupData.length === 0 || setupData?.[data?.key] === false
                      ? ICONS?.homeNotComplete
                      : ICONS?.homeSuccess
                  }
                  alt="icon"
                  className="w-5"
                  // className="w-[1.3vw] h-[1.3vw] mr-2"
                />

                <p className="w-100 font14px-400 text-[var(--textBlack)] pl-5">
                  {data?.title}
                </p>
              </div>
            ))}
          </div>
          <div className="flex flex-col items-center w-[70%] text-center px-8">
            <img src={ICONS?.homeWhatsapp} alt="homeWhatsapp" />
            <p className="font18px-600 text-[var(--textBlack)]">
              {selectedText?.subtitle}
            </p>
            <p className="font16px-400 text-[var(--font-600)] pt-2">
              {setupData?.length === 0 || setupData?.[selectedText?.key] === false
                ? selectedText?.description
                : selectedText?.content}
            </p>
            <div className="flex-row items-center pt-4">
              {selectedText?.button !== "Contact Sales" ? (
                <button
                  className={` font16px-500 py-2 px-3 rounded-md flex-row items-center ${
                    setupData?.length === 0 || setupData?.[selectedText?.key] === false
                      ? "bg-[#6940F224] text-[#6940F2] pointer"
                      : getButtonStyle()
                  }`}
                  // onClick={handleButtonClick}
                  onClick={() => {
                    if (setupData?.length === 0 || setupData?.[selectedText?.key] === false)
                      handleNavigate();
                  }}
                >
                  {setupData?.length === 0 || setupData?.[selectedText?.key] === false
                    ? selectedText?.button
                    : selectedText?.button1}
                  {selectedId !== 1 &&
                    (setupData?.length === 0 || setupData?.[selectedText?.key] === false) && (
                      <div className="pl-1.5">
                        {/* <img src={ICONS?.accountsArrow} />
                         */}
                        <Arrow
                          color={
                            setupData?.length === 0 || setupData?.[selectedText?.key] === false
                              ? "#6940F2"
                              : "var(--new-primary)"
                          }
                        />
                      </div>
                    )}
                </button>
              ) : (
                <span className="font16px-400 text-[var(--font-600)] italic">
                  Write us to{" "}
                  <a
                    href="https://mail.google.com/mail/u/0/?view=cm&to=contact@gainwix.com&tf=1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pointer text-[#6564CA] font16px-400 italic border-b-[1px] border-[#6564CA]"
                  >
                    contact@gainwix.com
                  </a>{" "}
                  to get your Brand new verify
                </span>
              )}
              {/* <button className="text-[#616874] font-[500] text-[0.9rem] pl-6 flex-row items-center">
                Watch Demo
                <span className="pl-1.5">
                  <img src={ICONS?.accountsArrow} />
                </span>
              </button> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatAppBusiness;
